const selectors = {
    selectBox : document.querySelector('#ContactForm-subject')
  };

  class TemplateContactJS {
    constructor() {
        this.form();
    }

    form(){
        // Custom code for Contact page goes here
       selectors.selectBox.addEventListener('change', (e) => {
            let data = e.currentTarget.value;
            if(data == 'Track my order'){
                document.querySelector('[data-trackOrder]').innerHTML =`
                        <input type="text" id="ContactForm-track-order" class="form-control" name="contact[order_number]" value="" placeholder="Order Number *" required>
                    </div>`;
            } else {
                document.querySelector('[data-trackOrder]').innerHTML = '';
            }
     
        });
    }
}

typeof TemplateContactJS !== 'undefined' && new TemplateContactJS();



